import { render, staticRenderFns } from "./LevTable2.vue?vue&type=template&id=2f6930ae&scoped=true"
import script from "./LevTable2.vue?vue&type=script&lang=js"
export * from "./LevTable2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6930ae",
  null
  
)

export default component.exports